// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SearchComponent } from "./processing-search.component";
import { SashaBreadcrumbModule } from '../../shared/components/breadcrumb/sasha-breacrumb.module';
import { ProcessingSearchRouting } from "./processing-search.routing";
import { ProcessingSearchFormModule } from '../../shared/components/processing-search-form/processing-search-form.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    imports: [
        CommonModule,
        ProcessingSearchRouting,
        SashaBreadcrumbModule,
        ProcessingSearchFormModule,
        TitleServiceModule,
    ],
    declarations: [
        SearchComponent,
    ]
})
export class ProcessingSearchModule { }